/**
 * Clears all keys for this origin (auth, API caches, etc.).
 * Call on logout so no user data or cached responses remain.
 */
export function clearAllLocalStorage() {
  try {
    localStorage.clear();
  } catch (e) {
    console.warn('localStorage.clear failed', e);
  }
}
